import * as React from 'react';
export const revolutSvg = React.forwardRef(function revolutSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8.833.027c1.577.082 2.57.27 3.611.856.807.454 1.423 1.143 1.86 1.988.23.449.347.9.434 1.464.07.46.086.926.044 1.386a5.022 5.022 0 0 1-.13.824 4.776 4.776 0 0 1-.675 1.502 6.126 6.126 0 0 1-1.115 1.23l-.156.127.107.31c.397 1.12.765 1.949 1.206 2.685l.17.272.143.218c.45.66.525 1.3 0 1.901-.392.45-1.185 1.064-3.833 1.205-1.095.059-1.974-.435-2.576-1.205-.097-.137-.307-.126-.411.006a2.547 2.547 0 0 1-1.043.767l-.214.078-.229.071a6.326 6.326 0 0 1-1.542.266c-3.92.14-3.468-2.989-3.468-2.989h-.007l.7-4.098s.15-.924.241-1.518c.094-.607.233-1.556.233-1.556l.12-.822.14-1.19.074-.76c.016-.341.016-.62 0-.877l.103-.513.053-.236c.063-.236.126-.35.252-.485L3.051.81l.077-.072c.28-.244.486-.324.78-.402A3.54 3.54 0 0 1 4.213.27L4.54.223l.714-.076a21.82 21.82 0 0 1 3.579-.12ZM4.27 2.077c-.002-.07.77-.144 1.129-.179l.057-.005a20.05 20.05 0 0 1 3.282-.11c.975.05 1.976.144 2.844.632.516.29.892.743 1.16 1.262.142.277.212.62.259.927.049.32.06.645.032.968l-.023.21a2.74 2.74 0 0 1-.063.339 3.025 3.025 0 0 1-.427.948 4.628 4.628 0 0 1-1.008 1.044 7.708 7.708 0 0 1-.88.59c.63 2.035 1.293 3.325 2.18 5.024-.14.16-1.092.447-2.408.517a1.206 1.206 0 0 1-.835-.267c-.401-.317-.56-.804-.56-.804L7.852 9.82a.406.406 0 0 0-.384-.273h-.91c-.297 1.9-.42 2.985-.42 4.182 0 0-.14.34-1.825.505-.464.045-1.126-.01-1.385-.463-.245-.429-.133-.98-.035-1.461l.058-.296.06-.344c.181-1.014.362-2.027.523-3.045.173-1.09.353-2.297.511-3.39l.03-.248.008-.075c.065-.551.177-1.503.188-1.786a9.794 9.794 0 0 0 0-1.048Zm2.562 5.7s.335-1.593.639-4.224c1.267-.207 2.644.043 2.32 2.07-.352 2.193-1.832 2.17-2.696 2.155h-.262Z',
      clipRule: 'evenodd',
    }),
  );
});
revolutSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var revolut = {
  category: 'paymentmethod',
  colorable: true,
  name: 'revolut',
  svg: revolutSvg,
};
